import {CustomModuleField} from "../../../modules/custom-module-field/model/custom-module-field";

export class DynamicDataModel {
    moduleCustomFieldId: CustomModuleField;
    value: string;
}
